/* Delulu: open the Simply OTP login popup once, 10 seconds after the site opens (logged-out visitors only).
   Visitors close it with the cross as usual. Shown at most once per browser session (tab). */
(function () {
  var KEY = 'delulu_login_popup_shown';
  var DELAY = 10000;

  function alreadyShown() {
    try { return !!sessionStorage.getItem(KEY); } catch (e) { return false; }
  }
  function loggedIn() {
    return !!((window.__st && window.__st.cid) || (window.meta && window.meta.page && window.meta.page.customerId));
  }
  function busy() {
    var a = document.activeElement;
    return !!document.querySelector('.open-drawer, .nav-open, #sotp .sotp-popup-wrapper.active') ||
      !!(a && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName));
  }
  function open(retry) {
    if (alreadyShown() || loggedIn()) return;
    var s = window.simplyOtp;
    if (!s || typeof s.openPopup !== 'function') return;
    if (busy()) {
      if (retry) setTimeout(function () { open(false); }, 5000);
      return;
    }
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
    s.openPopup();
  }

  if (alreadyShown()) return;
  setTimeout(function () { open(true); }, DELAY);
})();
